import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, btn, input, Field, Modal } from "@/components/kit";
import { toast } from "sonner";
import { Plus, Trash2, ShieldCheck, User } from "lucide-react";

export default function Team() {
  const { user } = useAuth();
  const [members, setMembers] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "org_member" });

  const load = () => api.get("/team").then((r) => setMembers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const invite = async (e) => {
    e.preventDefault();
    try { await api.post("/team", f); toast.success("Member added"); setOpen(false); setF({ name: "", email: "", password: "", role: "org_member" }); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const remove = async (m) => {
    if (!window.confirm(`Remove ${m.name}?`)) return;
    try { await api.delete(`/team/${m.id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Team" subtitle="Invite colleagues to review and manage onboarding.">
        <button className={btn.primary} onClick={() => setOpen(true)} data-testid="invite-member-button"><Plus className="h-4 w-4" /> Add member</button>
      </PageHeader>

      <div className="bg-card border border-border divide-y divide-border">
        {members.map((m) => (
          <div key={m.id} className="flex items-center justify-between px-6 py-4" data-testid={`member-row-${m.id}`}>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-10 w-10 bg-secondary">{m.role === "org_admin" ? <ShieldCheck className="h-5 w-5" /> : <User className="h-5 w-5" />}</span>
              <div>
                <p className="font-medium">{m.name} {m.id === user?.id && <span className="text-xs text-muted-foreground">(you)</span>}</p>
                <p className="text-sm text-muted-foreground">{m.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs px-2.5 py-1 bg-secondary font-medium capitalize">{m.role.replace("org_", "")}</span>
              {m.id !== user?.id && <button onClick={() => remove(m)} className="p-2 hover:bg-secondary text-destructive" data-testid={`remove-member-${m.id}`}><Trash2 className="h-4 w-4" /></button>}
            </div>
          </div>
        ))}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="Add team member" testid="invite-modal">
        <form onSubmit={invite} className="space-y-4">
          <Field label="Name"><input required className={input} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="member-name" /></Field>
          <Field label="Email"><input type="email" required className={input} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="member-email" /></Field>
          <Field label="Temporary password"><input required minLength={6} className={input} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="member-password" /></Field>
          <Field label="Role"><select className={input} value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="member-role"><option value="org_member">Member</option><option value="org_admin">Admin</option></select></Field>
          <button type="submit" className={`${btn.primary} w-full`} data-testid="member-submit">Add member</button>
        </form>
      </Modal>
    </div>
  );
}
